;(function () {
  window.initSelectableLists = function (scope) {
    var openElement, selector, setSelectableItemState
    setSelectableItemState = function (item, state) {
      var checkbox, isActive
      checkbox = $(item).find('input[type="checkbox"]')
      isActive = checkbox.prop("checked")
      if (state !== void 0) {
        if (isActive) {
          checkbox.prop("checked", false)
        } else {
          checkbox.prop("checked", "checked")
        }
        isActive = !isActive
      }
      return $(item).toggleClass("active", isActive)
    }
    $(scope)
      .findIncludingSelf(".items.selectable:not(.vuejs)")
      .each(function (_, el) {
        var $chkboxes, lastChecked
        $chkboxes = $(el).find(".item")
        lastChecked = null
        return $chkboxes.click(function (e) {
          var end, start
          if (!lastChecked) {
            lastChecked = this
          }
          if (e.shiftKey) {
            start = $chkboxes.index(this)
            end = $chkboxes.index(lastChecked)
            $chkboxes
              .slice(Math.min(start, end) + 1, Math.max(start, end))
              .each(function (_, e) {
                return setSelectableItemState(e, true)
              })
          }
          return (lastChecked = this)
        })
      })
    $(scope)
      .findIncludingSelf(".items.selectable .item")
      .each(function (_, el) {
        return setSelectableItemState(el)
      })
    $(scope)
      .findIncludingSelf(".items.selectable .item")
      .click(function (e) {
        var item
        item = $(e.target).closest(".item")
        return setSelectableItemState(item, item.hasClass("active"))
      })
    openElement = false
    selector =
      ".items:not(.selectable):not(.vuejs) .item:has(.extra), " +
      ".items.selectable:not(.vuejs) .item .icon.chevron"
    return $(scope)
      .findIncludingSelf(selector)
      .click(function (e) {
        var el, isActive, isExpanded, isInactive, isSelectable, item
        el = e.target
        item = $(el).closest(".item")
        isSelectable = item.parent().hasClass("selectable")
        isExpanded = item.hasClass("expanded")
        isActive = item.hasClass("active")
        isInactive = item.hasClass("inactive")
        if (isSelectable) {
          e.stopPropagation()
        }
        if ($(el).closest("a.title").length > 0) {
          e.preventDefault()
          e.stopPropagation()
        }
        if ($(el).closest(".ui.button").length > 0) {
          return
        }
        if (!(isInactive || isSelectable)) {
          if (isActive) {
            item.removeClass("active")
            openElement = false
          } else {
            item.addClass("active")
            if (!(isSelectable && openElement)) {
              $(openElement).trigger("click")
            }
            openElement = item
          }
        }
        if (isExpanded) {
          item.addClass("closing")
        } else {
          item.addClass("opening")
        }
        return item
          .find(".description, .extra")
          .slideToggle(isExpanded, function () {
            if (isExpanded) {
              item.removeClass("expanded")
              item.removeClass("closing")
            } else {
              item.addClass("expanded")
              item.removeClass("opening")
            }
            if (isActive && !isSelectable) {
              return item.removeClass("active")
            }
          })
      })
  }
}).call(this)
